import React from 'react';
import {Typography} from "@material-tailwind/react";
import {
    GlobeAltIcon, EnvelopeIcon
} from "@heroicons/react/24/outline";
import {LandingMenu} from "../components/common/LandingMenu";
import {PhoneIcon} from "@heroicons/react/16/solid";
import {Link} from "react-router-dom";
import {Menu} from "../components/common/Menu";

import { motion } from 'framer-motion';

function SavetiPage() {

    const isAuthenticated = !!localStorage.getItem("token");

    const currentYear = new Date().getFullYear();

    return (
        <>
            <div className="overflow-hidden">
                <div className="justify-center w-[calc(100%)] min-h-screen bg-white">
                    <div className="h-5 bg-gray-50"></div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        {/* Levi krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob"
                             style={{ top: '90%', left: '30%', transform: 'translate(-80%, -50%)' }}></div>
                        {/* Desni krug */}
                        <div className="absolute w-[35vw] h-[35vw] bg-red-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-2000"
                             style={{ top: '80%', left: '60%', transform: 'translate(-20%, -50%)' }}></div>
                        {/* Donji krug */}
                        {/*<div className="absolute w-[35vw] h-[35vw] bg-blue-100 rounded-full mix-blend-multiply filter blur-2xl opacity-50 animate-blob animation-delay-4000"*/}
                        {/*     style={{ top: '120%', left: '60%', transform: 'translate(-50%, 10%)' }}></div>*/}
                    </div>
                    <div className="mx-2">
                        {isAuthenticated ? <Menu /> : <LandingMenu />}

                        <motion.div
                            initial={{ opacity: 0, y: -100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.75 }}
                        >

                        <div className="h-6 bg-grayblue-50"></div>
                        <div className="container mx-auto flex flex-col relative z-10">
                            <div className="relative h-[75vh] w-full">
                                {/* Slika u pozadini */}
                                <img
                                    className="absolute inset-0 h-full w-full object-cover object-center rounded-xl"
                                    src="/images/saveti-page/pozadina%20saveti.jpg"
                                    alt="Saveti"
                                />
                                {/*<div className="absolute inset-0 bg-black/40 rounded-xl"></div>*/}

                                {/* Hero tekst */}
                                <div className="absolute inset-0 flex flex-col items-start justify-center px-8 sm:px-16 lg:px-24 text-white space-y-6">
                                    <h1 className="text-3xl sm:text-5xl lg:text-5xl font-bold leading-tight text-blue-gray-400">
                                        Saveti
                                    </h1>
                                    <h2 className="text-xl sm:text-3xl lg:text-3xl font-medium text-blue-gray-700">
                                        Saveti za<br /> racionalnu potrošnju<br/> toplotne energije
                                    </h2>
                                    <br/>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mt-12">
                                {/* Prvi red */}

                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/3.jpg" alt="Postavite termostat na optimalnu temperaturu" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Postavite termostat na optimalnu temperaturu</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Podesite termostat tako da ne bude previše visok (oko 21°C je preporučeno za dnevne aktivnosti).<br/> Prekomerno povećanje temperature ne znači nužno veći komfor, već samo veću potrošnju energije.</p>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/2.jpg" alt="Smanjite temperaturu kada izlazite iz stana ili kuće" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Smanjite temperaturu kada izlazite iz stana ili kuće</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Ako planirate da budete van svog doma duže vreme (na primer, na poslu ili na kraćim putovanjima), smanjite temperaturu grejanja dok niste kod kuće. <br/>To će smanjiti nepotrebnu potrošnju energije, a kada se vratite, lako možete podići temperaturu na željeni nivo.</p>
                                    </div>
                                </div>

                                {/* Drugi red */}
                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/1.jpg" alt="Podesite temperaturu grejanja na niže tokom noći" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Podesite temperaturu grejanja na niže tokom noći</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Kada spavate, temperatura može biti niža bez da se osećate neprijatno. <br/>Smanjenje temperature za 2-3 stepena noću može značajno uštedeti energiju.</p>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/4.jpg" alt="Zatvorite vrata i prozore kada koristite grejanje" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Podesite prozore i proverite zaptivne gume</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Podesite prozore na zimski režim i proverite zaptivne gume na vratima i prozorima.<br/> Ove mere će sprečiti gubitak toplote i pomoći vam da uštedite energiju tokom zime.</p>
                                    </div>
                                </div>

                                {/* Treći red */}
                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/istockphoto-1368214406-612x612.jpg" alt="Držite termostat na stalnoj temperaturi" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Racionalna potrošnja tople sanitarne vode</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Ukoliko zagrevate sanitarnu vodu pomoću gasnog kotla, budite racionalni pri korišćenju, jer tako možete smanjiti račune za gas.</p>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/6.jpg" alt="Redovno proveravajte sistem grejanja" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Redovno proveravajte sistem grejanja</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Ako vaš sistem grejanja nije u optimalnom stanju, potrošnja energije može biti veća.<br/> Redovno održavanje i servisiranje sistema grejanja omogućava bolju efikasnost i manju potrošnju energije.</p>
                                    </div>
                                </div>

                                {/* Četvrti red */}
                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/7.jpg" alt="Izbegavajte previše otvaranje prozora zimi" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Izbegavajte previše otvaranje prozora</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Otvorite prozore samo kada je to neophodno za ventilaciju.<br/> Previše otvaranja prozora može izazvati gubitak toplotne energije, pa je bolje koristiti kratko provetravanje.</p>
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row items-center gap-6">
                                    <img className="h-36 w-36 rounded-lg object-cover" src="/images/saveti-page/8.jpg" alt="Ne blokirajte radijatore" />
                                    <div className="w-full sm:w-2/3 ml-3">
                                        <h2 className="text-2xl font-semibold text-gray-800">Ne blokirajte grejna tela</h2>
                                        <p className="mt-2 text-[16px] text-gray-600">Proverite da li su  radijatori prekriveni nameštajem ili zavesama, jer to može sprečiti pravilnu cirkulaciju toplote.<br/> Držite ih slobodnima da bi toplota efikasno došla do svih delova prostorije.</p>
                                    </div>
                                </div>
                            </div>



                            <div className="flex gap-4 mt-24 mb-4">
                                <footer className="relative w-full">
                                    <div className="mx-auto w-full max-w-7xl px-8">
                                        <div className="mx-auto grid w-full grid-cols-1 gap-8 py-12 md:grid-cols-2 lg:grid-cols-4">

                                            <div className="w-full flex items-center justify-start lg:justify-center">
                                                <img
                                                    src="/transparent logo.png"
                                                    alt="Smart Service System Logo"
                                                    className="h-24 w-auto"
                                                />
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Navigacija
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Link to="/">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Početna strana</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/o_nama">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">O nama</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/saveti">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Saveti</span>
                                                        </Typography>
                                                    </Link>
                                                    <Link to="/kontakt">
                                                        <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                            <span className="inline-block py-1 pr-2">Kontakt</span>
                                                        </Typography>
                                                    </Link>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <Typography variant="small" className="mb-4 font-bold uppercase text-gray-900">
                                                    Kontakt
                                                </Typography>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">Za sva Vaša pitanja</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">stojimo na raspolaganju</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">svakog radnog dana</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">od 12-14h</span>
                                                    </Typography>
                                                </ul>
                                            </div>

                                            <div className="w-full">
                                                <div className="flex items-center space-x-4 mb-4">
                                                    <GlobeAltIcon className="h-5 w-5 text-gray-900" />
                                                    <EnvelopeIcon className="h-5 w-5 text-gray-900" />
                                                    <PhoneIcon className="h-5 w-5 text-gray-900" />
                                                </div>
                                                <ul className="space-y-1">
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">www.smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">info@smartservicesystem.rs</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <span className="inline-block py-1 pr-2">+381 61 528 00 18</span>
                                                    </Typography>
                                                    <Typography as="li" color="blue-gray" className="font-light text-gray-600">
                                                        <a  href="/Politika%20privatnosti.pdf" target="_blank" rel="noopener noreferrer" className="inline-block py-1 pr-2">Politika privatnosti</a>
                                                    </Typography>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="flex w-full flex-col items-center justify-center border-t border-blue-gray-50 py-4 md:flex-row md:justify-between">
                                            <Typography
                                                variant="small"
                                                className="mb-4 text-center font-normal text-blue-gray-900 md:mb-0"
                                            >
                                                &copy; {currentYear} <a href="https://smartservicesystem.rs/">Smart Service System</a>. Sva
                                                prava zadržana.
                                            </Typography>
                                        </div>
                                    </div>
                                </footer>
                            </div>

                        </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SavetiPage;